var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classStyle }, [
    _vm._v(_vm._s(_vm.formated_value))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Kpi/Kpivalue.vue?vue&type=template&id=7a83d760&
// module id = null
// module chunks = 